import clsx from "clsx"
import emitter from "../../eyejack-web-core/src/core/events/eventemitter";
import {  useRef } from "preact/hooks";

interface XRLaunchButtonProps {
    onClick?: () => void;
    disabled?: boolean;
}

export const XRLaunchButton = ({ onClick, disabled }: XRLaunchButtonProps) => {

    const qrCodeBoxRef = useRef(null);

    const handleClick = () => {
        if (onClick) onClick()
        emitter.emit('xr-start');
    }

    return (
        <div ref={qrCodeBoxRef} className="relative w-full h-full">
            <button
                disabled={disabled}
                className={clsx(
                    'flex relative justify-center items-center text-lg w-[242px] h-[63px]  border-2 tracking-[1.8px] ',
                    'animate-fade-in',
                    'disabled:opacity-50',
                )}
                onClick={handleClick}
            >
                <span className="relative font-inter-bold">
                    BEGIN
                </span>
            </button>
        </div>
    )
}